import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { checkIsSuperAdmin } from '../services/adminService'
import { motion } from 'framer-motion'

const AdminRoute = ({ children }) => {
  const { user, loading: authLoading } = useAuth()
  const [isAdmin, setIsAdmin] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const verifyAdminStatus = async () => {
      console.log('🔐 AdminRoute: Verifying admin status for user:', user?.id)
      
      if (!user) {
        console.log('🔐 AdminRoute: No user found')
        setIsAdmin(false)
        setLoading(false)
        return
      }

      try {
        console.log('🔐 AdminRoute: Calling checkIsSuperAdmin...')
        const adminStatus = await checkIsSuperAdmin()
        console.log('🔐 AdminRoute: Admin status result:', adminStatus)
        setIsAdmin(adminStatus)
      } catch (error) {
        console.error('🔐 AdminRoute: Error verifying admin status:', error)
        setIsAdmin(false)
      } finally {
        setLoading(false)
      }
    }

    if (!authLoading) {
      console.log('🔐 AdminRoute: Auth not loading, starting verification')
      verifyAdminStatus()
    } else {
      console.log('🔐 AdminRoute: Auth still loading...')
    }
  }, [user, authLoading])

  // Show loading state
  if (authLoading || loading) {
    return (
      <div className="min-h-screen bg-surface flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="text-center"
        >
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
            className="w-16 h-16 bg-accent rounded-lg flex items-center justify-center text-white text-3xl  mx-auto mb-6"
          >
            ⚡
          </motion.div>
          <p className="text-text-secondary font-semibold">Verifying admin access...</p>
        </motion.div>
      </div>
    )
  }

  // Not logged in
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // Not an admin
  if (isAdmin === false) {
    return (
      <div className="min-h-screen bg-surface flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-card rounded-lg  p-8 max-w-md w-full text-center"
        >
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-4xl">🚫</span>
          </div>
          <h1 className="text-2xl font-bold text-text-primary mb-2">Access Denied</h1>
          <p className="text-text-secondary mb-6">
            You don't have permission to access the admin dashboard.
          </p>
          <button
            onClick={() => window.history.back()}
            className="px-6 py-3 bg-accent text-white rounded-xl font-semibold hover:bg-interactive-hover transition-colors"
          >
            Go Back
          </button>
        </motion.div>
      </div>
    )
  }

  // User is admin - render children
  return children
}

export default AdminRoute